module.exports = __webpack_public_path__ + "static/img/AIprogram.eec8556.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/fourthToolList/AIprogram.png
// module id = GbKI
// module chunks = 3